import { render, staticRenderFns } from "./CityAddress.vue?vue&type=template&id=a4fac56c&scoped=true"
import script from "./CityAddress.vue?vue&type=script&lang=js"
export * from "./CityAddress.vue?vue&type=script&lang=js"
import style0 from "./CityAddress.vue?vue&type=style&index=0&id=a4fac56c&prod&lang=scss&scoped=true"
import style1 from "./CityAddress.vue?vue&type=style&index=1&id=a4fac56c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fac56c",
  null
  
)

export default component.exports